import React, { useContext } from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router'
import { StoresContext } from '@App/contexts'
import clsx from 'clsx'
import Pluralize from 'pluralize'
import { useFlag } from '@openfeature/react-sdk'

interface MemberSongwriterHandlerProps {
    type: 'member' | 'songwriter'
    count: number
    firstNavLink?: string
    onClick?: () => void
}

const MemberSongwriterHandler = ({ type, count, firstNavLink, onClick }: MemberSongwriterHandlerProps) => {
    const { popupStore, uiStore } = useContext(StoresContext)
    const { value: songwriterRelease } = useFlag('songwriter-release', false)
    const isOpen = popupStore.rightsholderTrayState
    const isMemberHub = type === 'member'
    const isSelected = uiStore.homePageState === type

    if (count === 0) {
        return null
    }

    const label = isMemberHub ? (songwriterRelease ? 'Member Hub' : Pluralize('Member', count)) : 'Songwriter Hub'

    return (
        <div
            className={clsx('hub-handler-component', isOpen && 'open', isSelected && 'selected')}
            data-testid="hub-handler"
        >
            {count === 1 && firstNavLink ? (
                <NavLink to={firstNavLink} onClick={onClick} className="hub-handler">
                    <img src={ICONS.account} alt="Top Rightsholder" />
                    <span className="bold">{label}</span>
                </NavLink>
            ) : (
                <div className="hub-handler" onClick={onClick}>
                    {isOpen && isMemberHub ? (
                        <img src={ICONS.chevron_drop_up} alt="Close" />
                    ) : (
                        <img src={ICONS.account_multi} alt="Top Rightsholders" />
                    )}
                    <span className="bold">
                        {label} &nbsp;
                        {count > 1 && <span className="count">{'(' + count + ')'}</span>}
                    </span>
                </div>
            )}
        </div>
    )
}

export default observer(MemberSongwriterHandler)
